import { openOAuthWindow } from '../utils/openOAuthWindow';
import { captureMessage } from '../../internal/ravenUtils';

/**
 * Opens the OAuth popup synchronously for the headless flow.
 *
 * The popup must be opened in the same tick as the user gesture, otherwise the
 * browser (Safari in particular) blocks it. This warns when it detects the call
 * did not originate from a user activation so integrators get an actionable
 * message before the popup silently fails.
 */
export function openHeadlessOAuthWindow(
  appName: string | undefined
): Window | null {
  const activation = window.navigator.userActivation as
    | UserActivation
    | undefined;

  if (activation && !activation.isActive) {
    captureMessage(
      'Headless auth flow started outside of a user gesture, the OAuth popup will likely be blocked',
      { extra: { appName } }
    );
    console.error(
      '[unified-account] A headless auth flow (mode="headless") was started ' +
        'outside of a user gesture, so the OAuth popup will likely be blocked ' +
        'by the browser. Invoke the trigger (button onClick / openModal) ' +
        'synchronously from a user interaction, without awaiting beforehand.'
    );
  }

  return openOAuthWindow(appName);
}
